// ssww-krushisetu\frontend\src\ColorFont\fontTheme.js

/* ================================================================
OLD UI CODE (COMMENTED OUT)
================================================================
export const fontThemes = {
    classic: {
        poppins: "Poppins",
   
    },
    modern: {
        poppins: "Nunito",

    },
    elegant: {
        poppins: "Playfair Display",
        },
    roboto:{
        poppins: "Roboto",
    },
    opensans:{
        poppins: "Open Sans",
    },
    oswald:{
        poppins: "Oswald",
    },
    montserrat:{
        poppins: "Montserrat",
    }
  };
*/

// ================================================================
// NEW UPDATED UI CODE (Figma Implementation)
// ================================================================

export const fontThemes = {
    // Figma CSS specifies 'Nunito' for Headings, Body, and Buttons
    classic: {
        poppins: "Nunito, sans-serif",
        manrope: "Nunito, sans-serif",
        publicSans: "Nunito, sans-serif",
    },
    modern: {
        poppins: "Poppins, sans-serif",
        manrope: "Poppins, sans-serif",
        publicSans: "Poppins, sans-serif",
    },
    elegant: {
        poppins: "'Playfair Display', serif",
        manrope: "'Playfair Display', serif",
        publicSans: "'Playfair Display', serif",
    },
    roboto: {
        poppins: "Roboto",
        manrope: "Roboto",
        publicSans: "Roboto",
    },
    opensans: {
        poppins: "Open Sans",
        manrope: "Open Sans",
        publicSans: "Open Sans",
    },
    oswald: {
        poppins: "Oswald",
        manrope: "Oswald",
        publicSans: "Oswald",
    },
    montserrat: {
        poppins: "Montserrat",
        manrope: "Montserrat",
        publicSans: "Montserrat",
    }
};